import React from 'react';
import JSZip from 'jszip';
import Papa from 'papaparse';
import { cloneDeep, isEmpty } from 'lodash';
import { saveAs } from 'file-saver';
import { Button, Menu, Dropdown, Select } from 'antd';
import { ChevronDown, Download } from 'lucide-react';
import { withRouter } from 'react-router-dom';

// V1 Basket Items filter bar — visual facelift only. Same 3 controls, same
// handlers, same URL-param protocol. Chrome is now v2: tag-Select + dropdown
// trigger + Export button all opted into `.mjl-ds` portal overrides, icons
// swapped to Lucide, layout shifted from AntD Row/Col to a flex composition
// that wraps cleanly on narrow viewports.

const FilterBar = withRouter((props) => {
  const { data, location, history, setOrderIdVal, params, dropdownFilter, permission } = props;

  const exportData = permission && permission.exportData;

  const keyMap = {
    0: 'All Time',
    1: 'Last 7 Days',
    2: 'Last 15 Days',
    3: 'Last 30 Days',
    4: 'Last 60 Days',
    5: 'Last 90 Days',
  };

  const handleMenuClick = (e) => {
    const key = keyMap[e.key];

    params.delete('df');
    params.append('df', key);
    history.push(`${location.pathname}?${params.toString()}`);
  };

  const dateFilterMenu = (
    <Menu onClick={handleMenuClick}>
      {Object.entries(keyMap).map(([key, value]) => (
        <Menu.Item key={key}>{value}</Menu.Item>
      ))}
    </Menu>
  );

  const handleChange = (s) => {
    setOrderIdVal('');
    params.delete('orderId');
    params.delete('search');

    if (s && s.length) {
      s.forEach((item) => params.append('search', item));
    }
    history.push(`${location.pathname}?${params.toString()}`);
  };

  const handleExport = () => {
    try {
      const zip = new JSZip();
      const folder = zip.folder('Reports Campaign Basket Item');
      const dupFileData = cloneDeep(data);

      const csvContent = Papa.unparse(dupFileData, {
        encoding: 'UTF-8',
        quotes: true,
        quoteChar: '"',
      });
      const BOM = '﻿';
      const csvContentWithBOM = BOM + csvContent;
      folder.file('Basket Items.csv', csvContentWithBOM, {
        binary: false,
        type: 'text/csv;charset=UTF-8',
      });

      zip
        .generateAsync({
          type: 'blob',
          compression: 'DEFLATE',
          compressionOptions: { level: 9 },
        })
        .then(
          (blob) => {
            saveAs(blob, 'Campaigns.zip');
          },
          (e) => {
            console.error('Error exporting CSV:', e);
          }
        );
    } catch (err) {
      console.error('Error exporting CSV:', err);
    }
  };

  return (
    <div className="campaign-basket-items-v1__filter-bar">
      <div className="campaign-basket-items-v1__filter-bar-title mono-eyebrow">
        Basket Items
      </div>
      <div className="campaign-basket-items-v1__filter-bar-controls">
        <Select
          mode="tags"
          allowClear
          className="campaign-basket-items-v1__filter-search"
          popupClassName="mjl-ds"
          placeholder="Search multiple basket items by name"
          onChange={handleChange}
          defaultValue={[]}
        />
        <Dropdown overlay={dateFilterMenu} overlayClassName="mjl-ds" trigger={['click']}>
          <Button className="campaign-basket-items-v1__filter-range">
            <span>{dropdownFilter || 'All Time'}</span>
            <ChevronDown size={14} strokeWidth={2} />
          </Button>
        </Dropdown>
        {exportData && (
          <Button
            type="primary"
            className="campaign-basket-items-v1__filter-export"
            disabled={isEmpty(data)}
            onClick={handleExport}
          >
            <Download size={14} strokeWidth={2} />
            <span>Export CSV</span>
          </Button>
        )}
      </div>
    </div>
  );
});

export default FilterBar;
